export default __webpack_public_path__ + "static/media/terraceparty2020.173c68d0.mp4";